import React from "react";
import { TrendingDown } from "lucide-react";

// Cart line nudge: next two bulk tiers, e.g. "Add 1 more for 5% off" / "Add 3 more for 15% off" (retail lines only).
export default function CartTierNudge({ item, onUpgrade }) {
  if (item.is_wholesale) return null;
  const options = (item.tiers || [])
    .slice()
    .sort((a, b) => a.min_qty - b.min_qty)
    .filter((t) => t.min_qty > item.quantity && t.unit_price < item.unit_price)
    .slice(0, 2);
  if (!options.length) return null;
  const single = (item.tiers || []).find((t) => t.min_qty === 1)?.unit_price || item.unit_price;

  return (
    <div data-testid={`cart-tier-nudge-${item.slug}`} className="mt-2 space-y-1.5">
      {options.map((t) => {
        const need = t.min_qty - item.quantity;
        const pct = Math.round((1 - t.unit_price / single) * 100);
        return (
          <button
            key={t.min_qty}
            type="button"
            data-testid={`cart-tier-nudge-${item.slug}-${t.min_qty}`}
            onClick={() => onUpgrade(t.min_qty)}
            className="w-full text-left flex items-start gap-2 px-3 py-2 border border-[#00C3FF]/40 bg-[#00C3FF]/5 hover:bg-[#00C3FF]/10 transition-colors"
          >
            <TrendingDown size={12} className="text-[#00C3FF] mt-0.5 shrink-0" />
            <span className="font-mono-tech text-[10px] leading-relaxed text-[#8A94A6]">
              <span className="text-[#00C3FF] uppercase tracking-[0.15em]">Add {need} more for {pct}% off</span>
              <br />{t.min_qty} vials at ${t.unit_price.toFixed(2)}/vial (vs ${single.toFixed(2)})
            </span>
          </button>
        );
      })}
    </div>
  );
}
